import { IGameCharacter } from "../type"
import json from "./json/character.json"

const CHARACTER_DICT: Record<string, IGameCharacter> = json

export default CHARACTER_DICT
